import React from 'react';

import Modal from 'components/Modal';
import PasswordRequestForm from 'components/PasswordRequestForm';

export default function PasswordResetRequestModalComponent(props) {
  const { isOpen, onRequestClose } = props;
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <PasswordRequestForm />
    </Modal>
  );
}